module.exports = __webpack_public_path__ + "img/download_xiaochengxu.2055670f.png";